'use strict';
const _ = require('lodash');

const AnnotationLayerEditorController = function ($scope, Flux) {

  const vm = this;
  const MapActions = Flux.Actions.get('MapActions');
  const AnnotationStore = Flux.Store.get('AnnotationStore');

  vm.colors = _.pluck(AnnotationStore.COLORS, 'color');

  vm.areameasurement = false;

  vm.deleteLayer = () => {

    MapActions.DeleteActiveAnnotationLayer.dispatch();
  };

  vm._handleColorSelected = (ev, data) => {

    let style = vm.annotationLayer.data.properties.style;

    if (!style) {
      vm.annotationLayer.data.properties.style = {};
      style = vm.annotationLayer.data.properties.style;
    }
    style.color = data;
    vm.annotationLayer.data.properties.style.color = data;
    const newLayerName = AnnotationStore.getAnnotationLayerName(
      vm.annotationLayer.data,
      vm.annotationLayer.type,
      style.color,
      vm.annotationLayer.label
    );
    AnnotationStore.renameAnnotationLayer(
      vm.annotationLayer.id,
      newLayerName
    );
    // Need to refresh label since annotationLayer is a clon of the original attr
    vm.annotationLayer.label = newLayerName;
    vm.refreshLayerStyle({ color : data });
  };

  vm.hide = () => {

    $scope.$emit('annotationLayer:editor:close');
  };

  vm._handleAreaMeasurementChanged = (showMeasurements) => {

    if (typeof showMeasurements !== 'undefined') { // avoids reacting to a photoset popup
      vm.annotationLayer.data.properties.showMeasurements = showMeasurements;
      vm.refreshShowMeasurements(showMeasurements);
    }
    else {
      console.log('_handleAreaMeasurementChanged = undefined');
    }
  };

  $scope.$on('colorpicker:selected', vm._handleColorSelected.bind(vm));
  $scope.$watch(() => {

    return vm.showMeasurements;
  }, vm._handleAreaMeasurementChanged.bind(vm));

}

AnnotationLayerEditorController.$inject = ['$scope', 'sbFlux'];
module.exports = AnnotationLayerEditorController;



// WEBPACK FOOTER //
// ./src/app/dash/map/annotationLayerEditor/AnnotationLayerEditorController.js